import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateTermsAndConditionSchema } from "@/v2/schema/terms-and-conditions";
import { TermsAndCondition } from "@/v2/types";

export default async function CreateTermsAndCondition(
    data: CreateTermsAndConditionSchema,
): Promise<TermsAndCondition> {
    const res = await apiClientWithRefreshToken({
        url: "/terms-and-conditions-templates",
        method: "POST",
        data: data,
    });

    return res.data;
}
